import React from "react";
import { IonIcon, IonSpinner } from "@ionic/react";
import { videocamOutline } from "ionicons/icons";
import { ChatAttachment } from "./types";

type VideoAttachmentProps = { attachment: ChatAttachment };

const VideoAttachment = ({ attachment }: VideoAttachmentProps) => {
  const isPending = attachment.status === "pending";

  if (!attachment.signedUrl) {
    return (
      <div className="relative w-[260px] max-w-full aspect-video rounded-xl bg-gray-200 animate-pulse flex items-center justify-center">
        <IonIcon icon={videocamOutline} className="text-3xl text-gray-400" />
      </div>
    );
  }

  return (
    <div className="relative w-[260px] max-w-full">
      <video src={attachment.signedUrl} controls={!isPending} className="w-full rounded-xl" />
      {isPending && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 rounded-lg">
          <IonSpinner name="dots" />
        </div>
      )}
    </div>
  );
};

export default VideoAttachment;
